<header class="modal-header header">
  <span class="modal-title">{{ Localization.NewResidentNotification | translate }}</span>
  <a class="close pull-right"
      aria-label="Close"
      (click)="cancel()">
    <span aria-hidden="true">×</span>
  </a>
</header>
<main class="modal-body">

  <chapps-text-input [label]="Localization.Title"
                     [isRequired]="true"
                     [autofocus]="true"
                     [control]="notificationForm.controls.title"
                     data-cy="titleField"></chapps-text-input>
  <chapps-select-input [label]="Localization.Contact"
                       [items]="contactOptions$ | async"
                       [loading]="loadingResidents"
                       [control]="notificationForm.controls.contactId"
                       data-cy="contactSelect"></chapps-select-input>

  <fieldset class="form-field">
    <label>Location</label>
    <app-structure-location-tree [control]="notificationForm.controls.location"
                                 [endAt]="[StructureType.COMMERCIALUNIT, StructureType.LIVINGUNIT,
                                           StructureType.BUILDINGENVELOPEELEMENT, StructureType.EXTERIORELEMENT,
                                         StructureType.SPACE, StructureType.UTILITY]"
                                 [structureId]="targetId"
                                 ></app-structure-location-tree>
  </fieldset>

  <chapps-text-area-input [label]="Localization.Description"
                          [control]="notificationForm.controls.description"
                          data-cy="descriptionField"></chapps-text-area-input>

  <chapps-text-input [label]="Localization.Source"
                     [control]="notificationForm.controls.source"
                     data-cy="sourceField"></chapps-text-input>


</main>
<footer class="modal-footer footer">
  <chapps-secondary-button [label]="Localization.Cancel"
                           [small]="true"
                           [outline]="true"
                           (click)="cancel()"></chapps-secondary-button>
  <chapps-secondary-button [label]="Localization.Create"
                           [small]="true"
                           (click)="complete()"
                           [loading]="creatingNotification"
                           [disabled]="notificationForm.invalid"
                            data-cy="createButton"></chapps-secondary-button>
</footer>
